export default class MeioDeContato {
  id_meio_contato: number;
  nome: string;
  descricao: string;
}
